import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { MapContainer, Marker, Popup, TileLayer, useMapEvents } from "react-leaflet";
import { useEffect, useMemo, useRef, useState } from "react";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

const Map = ({ center, eventName, setFieldValue, editable, style, isStartAtPoint }) => {
  const [position, setPosition] = useState(null);
  const [isFirstClick, setIsFirstClick] = useState(false);
  useEffect(()=>{
    if(!editable){
      setPosition(center);
    }
    if(isStartAtPoint){
      setPosition(center)
    }
  }, [editable]);
  const LocationMarker = () => {
    const markerRef = useRef(null);
    const eventHandlers = useMemo(
      () => ({
        dragend() {
          const marker = markerRef.current;
          if (marker != null) {
            const loc = marker.getLatLng();
            setPosition(loc);
            setFieldValue("lat", loc.lat);
            setFieldValue("lon", loc.lng);
          }
        }
      }),
      []
    );

    const map = useMapEvents({
      click(e) {
        map.locate();

        if (isFirstClick && editable) {
          setPosition(e.latlng);
          setFieldValue("lat", e.latlng.lat);
          setFieldValue("lon", e.latlng.lng);
        }
        setIsFirstClick(true);
      },
      locationfound(e) {
        if (position === null && editable) {
          setPosition(e.latlng);
          map.flyTo(e.latlng, map.getZoom());
          setFieldValue("lat", e.latlng.lat);
          setFieldValue("lon", e.latlng.lng);
        }
      }
    });
//TODO burada mevcut lokasyonu işaretliyor değiştirme işlemini kontrol etmek lazım.
    return position === null ? null : (
      <Marker draggable={editable} eventHandlers={eventHandlers} ref={markerRef} position={position}>
        <Popup>Event Location for {eventName}</Popup>
      </Marker>
    );
  };

  return <MapContainer center={center} zoom={15} style={style}>
    <TileLayer
      attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    />
    <LocationMarker />
  </MapContainer>;

};

export default Map;